import { render } from "./CourseItem.vue?vue&type=template&id=2d44c897&lang=true"
import script from "./CourseItem.vue?vue&type=script&lang=js"
export * from "./CourseItem.vue?vue&type=script&lang=js"

import "./CourseItem.vue?vue&type=style&index=0&id=2d44c897&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__